import {
  EXISTING_USER_AUTHENTICATED,
  NEW_USER_AUTHENTICATED,
  USER_LOGOUT,
} from './currentUser.actions'
import { CurrentUser } from './../../providers/currentUser'

const INITIAL_STATE = new CurrentUser().get()

export const currentUserReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case EXISTING_USER_AUTHENTICATED:
      return action.state
    case NEW_USER_AUTHENTICATED:
      return action.state
    case USER_LOGOUT:
      return {}
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/currentUser/currentUser.reducers.js